var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('main-slider'),_c('section-project')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }